/**
 * The HR tab: HR Role only.
 *
 * Decided 9 Oct 2026 (docs/QUESTIONS.md, DECISION 9 Oct, item B) as the home
 * for HR-only screens in THIS app, answering "where do they live?" (5 Oct,
 * item e). Jeremy can move it.
 *
 * Tools arrive one PR at a time: the payroll balance upload, the NTD "also notify" list and
 * unpaid time off. The jury-duty "summons received" tick is on Approvals, where HR decides it.
 * Shown only when /people/me says isHr, and the API re-checks the role on every HR route.
 */
import { CompanyEvents } from "./CompanyEvents";
import { NtdNotifyList } from "./NtdNotifyList";
import { PayrollUpload } from "./PayrollUpload";
import { TrainingData } from "./TrainingData";
import { UnpaidTimeOff } from "./UnpaidTimeOff";
import { WorkReset } from "./WorkReset";

export function HrTab() {
  return (
    <section aria-labelledby="hr">
      <h2 id="hr" className="panel-title">HR</h2>
      <PayrollUpload />
      <UnpaidTimeOff />
      <NtdNotifyList />
      {/* Blackouts and information only (S25, S26; Jeremy, 1 Nov 2026). */}
      <CompanyEvents />
      <TrainingData />
      {/* Only while ALLOW_WORK_RESET is set on the App Service (Jeremy, 22 Oct 2026). */}
      <WorkReset />
    </section>
  );
}
